import React, { forwardRef, useMemo } from 'react';
import { FieldTypes, urlRegexValidator } from 'utils/formUtils';
import GenericPullCredentialsForm from '../GenericPullCredentialsForm';
import HashiCorpVaultRadarMappingForm from './HashiCorpVaultRadarMappingForm';

const HashiCorpVaultRadarCredentialsForm = forwardRef((props, ref) => {
    const fields = useMemo(() => [
        {
            name: "apiEndpoint",
            label: "API Endpoint",
            rules: [urlRegexValidator],
        },
        {
            name: "token",
            label: "Token",
            required: true,
            type: FieldTypes.PASSWORD,
        },
    ], [])
    return (
        <GenericPullCredentialsForm
            {...props}
            ref={ref}
            fields={fields}
            MappingForm={HashiCorpVaultRadarMappingForm}
        />
    )
});

export default HashiCorpVaultRadarCredentialsForm;